import {
  dataRequestBegin,
  dataRequestLoading,
  dataRequestCompleted,
  dataRequestFailure,
  dataRequestCancelled,
  dataRequestStatusReset,
} from 'app/dealer/shared/higherOrderReducers/withDataRequest/actionTypeFormatters';

import { LISTINGS_BENCHMARK_REDUCER_NAME } from '../constants';

export const listingsBenchmarkDataRequestBegin = payload =>
  dataRequestBegin(LISTINGS_BENCHMARK_REDUCER_NAME, payload);

export const listingsBenchmarkDataRequestLoading = () =>
  dataRequestLoading(LISTINGS_BENCHMARK_REDUCER_NAME);

export const listingsBenchmarkDataRequestComplete = payload =>
  dataRequestCompleted(LISTINGS_BENCHMARK_REDUCER_NAME, payload);

export const listingsBenchmarkDataRequestCancelled = payload =>
  dataRequestCancelled(LISTINGS_BENCHMARK_REDUCER_NAME, payload);

export const listingsBenchmarkDataRequestFailure = payload =>
  dataRequestFailure(LISTINGS_BENCHMARK_REDUCER_NAME, payload);

export const listingsBenchmarkDataResetStatusRequest = payload =>
  dataRequestStatusReset(LISTINGS_BENCHMARK_REDUCER_NAME, payload);

export const listingsApiProgressActions = {
  apiLoading: () => listingsBenchmarkDataRequestLoading(),
  apiCancelled: () => listingsBenchmarkDataRequestCancelled(),
};
